import { g as v } from "./index767.mjs";
import { f } from "./index758.mjs";
import { f as p } from "./index743.mjs";
import { t as c } from "./index749.mjs";
import { s as l } from "./index822.mjs";
import { w as u } from "./index823.mjs";
var s = v, h = f, T = p, b = c, g = l.trim, t = u, r = s.parseInt, i = s.Symbol, o = i && i.iterator, e = /^[+-]?0x/i, x = T(e.exec), I = r(t + "08") !== 8 || r(t + "0x16") !== 22 || o && !h(function() {
  r(Object(o));
}), j = I ? function(m, n) {
  var a = g(b(m));
  return r(a, n >>> 0 || (x(e, a) ? 16 : 10));
} : r;
export {
  j as n
};
